/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Insights_TitleInputs */

const en_why_listening_insights_title = /** @type {(inputs: Why_Listening_Insights_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get the gist before you listen`)
};

const es_why_listening_insights_title = /** @type {(inputs: Why_Listening_Insights_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capta la idea antes de escuchar`)
};

/**
* | output |
* | --- |
* | "Get the gist before you listen" |
*
* @param {Why_Listening_Insights_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_insights_title = /** @type {((inputs?: Why_Listening_Insights_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Insights_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_insights_title(inputs)
	return en_why_listening_insights_title(inputs)
});